import { computed, ref } from 'vue'

export interface Route {
  path: string
  name: string
}

const routeHistory = ref<Route[]>([])

export function useRouteHistory() {
  const addRoute = (route: Route) => {
    routeHistory.value = [...routeHistory.value, route]
  }

  const removeRoute = (route: Route) => {
    routeHistory.value = routeHistory.value.filter(
      item => item.path !== route.path,
    )
  }

  const lastRoute = computed(() => {
    const lastRoute = routeHistory.value[routeHistory.value.length - 1]
    return lastRoute?.name ? lastRoute : null
  })

  return {
    routeHistory,
    addRoute,
    removeRoute,
    lastRoute,
  }
}
